export default "__VITE_PUBLIC_ASSET__6a18bfb1__"